<template>
    <div class="container">
        <div class="handle-box-search">
            <el-row class="head-search">
                <!-- <el-col :span="8"> -->
                    <!-- <span class="title">客户姓名:</span> -->
                    <!-- 搜索客户姓名-->
                    <!-- <el-input -->
                        <!-- v-model="search_data.name" -->
                        <!-- placeholder="请输入客户姓名 " -->
                        <!-- class="handle-input mr10" -->
                        <!-- @keyup.enter.native="searchConsumerLists" -->
                    <!-- ></el-input> -->
                <!-- </el-col> -->

                <el-col :span="8">
                    <span class="title">用户类型:</span>
                    <!-- 搜索车牌号 -->
                    <el-select
                        v-model="search_data.has_order"
                        placeholder="请选择用户类型"
                        style="width: 150px; margin-right: 20px"
                        clearable
                    >
                        <el-option label="老用户" value="1"></el-option>
                        <el-option label="新用户" value="0"></el-option>
                    </el-select>
                </el-col>

                <el-col :span="12">
                    <span class="title">用户级别:</span>
                    <!-- 搜索车牌号 -->
                    <el-select v-model="search_data.is_vip" placeholder="请选择用户级别" style="width: 150px; margin-right: 20px" clearable>
                        <el-option label="vip用户" value="1"></el-option>
                        <el-option label="普通用户" value="0"></el-option>
                    </el-select>
                </el-col>

                <el-col :span="3">
                    <el-button :class="more_search ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" @click="more_search = !more_search">
                        详细搜索
                    </el-button>
                </el-col>
            </el-row>

            <el-row class="head-search">
                <el-col :span="8">
                    <span class="title">手机号码:</span>
                    <!-- 搜索手机号码 -->
                    <el-input
                        v-model="search_data.phone"
                        placeholder="请输入手机号码"
                        class="handle-input mr10"
                        maxlength="11"
                        @keyup.enter.native="searchConsumerLists"
                    ></el-input>
                </el-col>

                <el-col :span="12">
                    <span class="title">集团:</span>

                    <el-select
                        v-model="value_group_code"
                        placeholder="请选择集团"
                        @visible-change="groupList"
                        @change="groupChange"
                        clearable
                        @keyup.enter.native="searchOrderLists"
                        style="width: 150px; margin-right: 20px"
                    >
                        <el-option
                            v-for="item in options_group_code"
                            :key="item.value"
                            :label="item.group_name"
                            :value="item.group_wallet_code"
                        >
                        </el-option>

                        <el-pagination
                            class="pagination"
                            layout="prev, pager, next"
                            :total="selectPages_group_data.count"
                            :page-size="group_options_data.limit"
                            @current-change="selectPages_group_function"
                            :current-page="group_options_data.page"
                        />
                    </el-select>
                </el-col>
            </el-row>

            <el-row class="head-search">
                <el-col :span="8">
                    <span class="title">身份证号码:</span>
                    <!-- 搜索身份证号码 -->
                    <el-input
                        v-model="search_data.id_card"
                        placeholder="请输入身份证号码"
                        class="handle-input mr10"
                        @keyup.enter.native="searchConsumerLists"
                    ></el-input>
                </el-col>

            </el-row>

            <div v-show="more_search" style="margin-top: 10px">
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">车牌号:</span>
                        <!-- 搜索车牌号 -->
                        <el-input
                            v-model="search_data.car_number"
                            placeholder="请输入车牌号"
                            class="handle-input mr10"
                            @keyup.enter.native="searchConsumerLists"
                        ></el-input>
                    </el-col>
                </el-row>
            </div>

            <el-button type="primary" icon="el-icon-search" @click="searchConsumerLists">搜索</el-button>
            <el-button @click="add_isShow = !add_isShow">添加</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button @click="water_isShow = !water_isShow">后台调整乘客钱包流水</el-button>
        </div>
        <!-- 表格 -->
        <el-table
            :data="tableData"
            style="width: 100%"
            ref="multipleTable"
            header-cell-class-name="table-header"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand"
                        >

                        <div class="more-style">
                            <el-form-item label="紧急联系人姓名:">
                                <span>{{ props.row.urgent_name }}</span>
                            </el-form-item>
                            <el-form-item label="紧急联系人电话:">
                                <span>{{ props.row.urgent_phone }}</span>
                            </el-form-item>
                            <el-form-item label="注册渠道:">
                                <span>{{ props.row.reg_from.alias }}</span>
                            </el-form-item>
                        </div>
                        <div class="more-style">
                            <el-form-item label="平台:">
                                <span>{{ props.row.platform.alias }}</span>
                            </el-form-item>
                            <el-form-item label="APP版本:">
                                <span>{{ props.row.app_version }}</span>
                            </el-form-item>
                            <el-form-item label="极光编码:">
                                <span>{{ props.row.registration_id }}</span>
                            </el-form-item>
                        </div>

                        <div class="more-style">
                            <el-form-item label="注册时间:">
                                <span>{{ props.row.reg_time.Ymd }}</span>
                            </el-form-item>
                            <el-form-item label="注册详细时间:">
                                <span>{{ props.row.reg_time.YmdHis }}</span>
                            </el-form-item>
                            <el-form-item label="上次编辑时间:">
                                <span>{{ props.row.edit_time.Ymd }}</span>
                            </el-form-item>
                        </div>

                        <div class="more-style">
                            <el-form-item label="上次编辑详细时间:">
                                <span>{{ props.row.edit_time.YmdHis }}</span>
                            </el-form-item>
                            <el-form-item label="最后订单时间:">
                                <span>{{ props.row.last_order_time.Ymd }}</span>
                            </el-form-item>
                            <el-form-item label="最后订单详细时间:">
                                <span>{{ props.row.last_order_time.YmdHis }}</span>
                            </el-form-item>
                        </div>

                        <div class="more-style">
                            <el-form-item label="所在城市:">
                                <span>{{ props.row.city.name }}</span>
                            </el-form-item>

                            <el-form-item label="身份证号码:">
                                <span>{{ props.row.id_card }}</span>
                            </el-form-item>

                            <el-form-item label="车牌号码:">
                                <span>{{ props.row.car_number }}</span>
                            </el-form-item>
                        </div>

                        <el-form-item label="备注:">
                            <span>{{ props.row.remarks }}</span>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>

            <el-table-column prop="id" label="id" width="80"> </el-table-column>

            <el-table-column prop="name" label="客户名称" min-width="150">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                        <p>客户唯一编码: {{ scope.row.consumer_code }}</p>
                        <div slot="reference">
                            <el-tag size="medium" style="border: 0; background-color: #fff; color: #333">{{ scope.row.name }}</el-tag>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>

            <el-table-column prop="phone" label="手机电话" min-width="150"> </el-table-column>

            <el-table-column prop="city.name" label="所属城市" min-width="150"> </el-table-column>

            <el-table-column prop="last_order_time.YmdHis" label="最后一次下单时间" min-width="150"> </el-table-column>

            <el-table-column prop="order_num" label="已完成订单数量" min-width="150"> </el-table-column>

            <el-table-column prop="balance" label="余额">
                <template slot-scope="scope">
                    <span style="color: rgb(233, 161, 6)"> {{ scope.row.total_balance }}元 </span>
                </template>
            </el-table-column>

            <el-table-column label="性别">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.sex.val == '0' ? 'danger' : scope.row.sex.val == '1' ? '' : 'warning'">
                        {{ scope.row.sex.alias }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="用户级别">
                <template slot-scope="scope">
                    <el-tag :type="Number(scope.row.total_balance) > 0 ? 'success' : ''">
                        {{ Number(scope.row.total_balance) > 0 ? 'vip用户' : '普通用户' }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="管理状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status.val == '0' ? 'warning' : scope.row.status.val == '1' ? '' : 'danger'">
                        {{ scope.row.status.alias }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="用户类型">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.last_order_time.YmdHis == '未设置' ? 'warning' : ''">
                        {{ scope.row.last_order_time.YmdHis == '未设置' ? '新用户' : '老用户' }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-dropdown
                        split-button
                        type="primary"
                        @click="
                            edit_isShow = !edit_isShow;
                            consumer_code_children = scope.row.consumer_code;
                        "
                        trigger="click"
                    >
                        编辑

                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                                v-if="consumer_recharge_add == '1'"
                                @click.native="
                                    userWallet_isShow = !userWallet_isShow;
                                    consumer_code_children = scope.row.consumer_code;
                                "
                            >
                                用户钱包
                            </el-dropdown-item>

                            <el-dropdown-item
                                @click.native="
                                    userRecord_isShow = !userRecord_isShow;
                                    consumer_code_children = scope.row.consumer_code;
                                    consumer_name = scope.row.name;
                                    consumer_phone = scope.row.phone;
                                "
                            >
                                用户账单
                            </el-dropdown-item>

                            <el-dropdown-item
                                @click.native="
                                    sendCoupon_isShow = !sendCoupon_isShow;
                                    consumer_code_children = scope.row.consumer_code;
                                "
                            >
                                发放优惠券
                            </el-dropdown-item>

                            <el-dropdown-item
                                @click.native="
                                    editCoins_isShow = !editCoins_isShow;
                                    consumer_code_children = scope.row.consumer_code;
                                "
                            >
                                {{ proName }}币
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 添加用户信息组件 -->
        <addConsumer :isShow="add_isShow" @onSubmit="consumerLists"></addConsumer>
        <!-- 时间段乘客资金流水组件 -->
        <waterUserDrawer :isShow="water_isShow"></waterUserDrawer>

        <!-- 修改用户信息组件 -->
        <editConsumer :isShow="edit_isShow" :data="consumer_code_children" @onSubmit="consumerLists"></editConsumer>

        <!-- 用户钱包组件 -->
        <userWallet :data="consumer_code_children" :isShow="userWallet_isShow" @onSubmit="consumerLists"></userWallet>

        <!-- 用户账单组件 -->
        <userRecord :data="consumer_code_children" :isShow="userRecord_isShow" :name="consumer_name" :phone="consumer_phone"></userRecord>

        <!-- 发放优惠券组件 -->
        <sendCoupon :data="consumer_code_children" :isShow="sendCoupon_isShow"></sendCoupon>

        <!-- 九州币 -->
        <editCoins :data="consumer_code_children" :isShow="editCoins_isShow"></editCoins>
    </div>
</template>

<script>
var _this;
import bus from '../../common/bus.js';
import { config } from "@/utils/config";
import addConsumer from './addConsumer.vue';
import waterUserDrawer from './waterUserDrawer.vue';
import editConsumer from './editConsumer.vue';
import userWallet from './userWallet.vue';
import userRecord from './userRecord.vue';
import sendCoupon from './sendCoupon.vue';
import editCoins from './editCoins.vue';
export default {
    components: {
        addConsumer,
        waterUserDrawer,
        editConsumer,
        userWallet,
        userRecord,
        sendCoupon,
        editCoins
    },
    data() {
        return {
            proName: config.proType,

            water_isShow: false,
            // 乘客名称
            consumer_name: '',
            consumer_phone: '',

            editCoins_isShow: false,

            consumer_recharge_add: JSON.parse(localStorage.getItem('login')).consumer_recharge_add,

            // 添加用户信息组件开关
            add_isShow: false,

            // 修改用户信息组件开关
            edit_isShow: false,

            // 用户钱包组件开关
            userWallet_isShow: false,

            // 用户账单组件开关
            userRecord_isShow: false,

            // 发放优惠券开关
            sendCoupon_isShow: false,

            // 传入子组件的数据
            consumer_code_children: '',

            //详细搜索
            more_search: false,

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                name: '',
                phone: '',
                name: '',
                id_card: '',
                car_number: '',
                is_vip: '',
                has_order: ''
            },

            options_group_code: [],
            group_options_data: {
                page: 1,
                limit: 5
            },
            value_group_code: '',

            selectPages_group_data: [],

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;

        _this.consumerLists();

        // 接收子组件传来的事件并初始化列表
        bus.$on('onSubmit', (msg) => {
            _this.consumerLists();
        });
    },

    methods: {
        groupChange(val) {
            _this.search_data.group_wallet_code = val;
        },

        selectPages_group_function(search_data) {
            console.log(search_data);

            _this.group_options_data.page = search_data;

            _this.groupList();
        },

        groupList() {
            _this
                .$post('/group/groupWalletLists', _this.group_options_data)
                .then((res) => {
                    _this.selectPages_group_data = res;
                    _this.options_group_code = res.data;
                })
                .catch((err) => {});
        },

        searchConsumerLists() {
            _this.search_data.page = 1;
            _this.consumerLists();
        },
        // 搜索用户管理列表
        consumerLists() {
            _this
                .$post('/consumer/consumerLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            console.log(_this.search_data);

            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.consumerLists();
        },
        handleSelectionChange(val) {
            var datalist = [];

            for (var i in val) {
                datalist.push(val[i].driver_code);
            }
            _this.delDriverSubmit_data.driver_code_array = datalist;
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        },

        // 解绑设备
        untying(code) {
            _this
                .$post('/driver/untyingDriverMobileSubmit', {
                    driver_code: code
                })
                .then((res) => {
                    _this.$message.success('解绑设备成功');
                })
                .catch((err) => {});
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
